import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, toHandlers as _toHandlers, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "form-group-child" }
const _hoisted_2 = { for: "password" }
const _hoisted_3 = { class: "t-password-group" }
const _hoisted_4 = ["value", "type", "placeholder"]
const _hoisted_5 = {
  key: 0,
  class: "error-text",
  "data-qe-id": "password-current-error"
}

import { PasswordCurrent } from '@/model/Password'
import { ERROR_CODES } from '@/model/ERROR_CODES'
import { Ref, computed, ref, useAttrs, watch } from 'vue'

interface Props {
  validate?: boolean
  modelValue: PasswordCurrent
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PasswordCurrentInput',
  props: {
    validate: { type: Boolean },
    modelValue: {}
  },
  emits: ['update:modelValue', 'reset'],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const attrs = useAttrs()

const _validatePassword = (s: string) => {
  return {
    value: s,
    valid: s.length > 0,
    errorCode: s.length > 0 ? undefined : ERROR_CODES.required,
    length: s.length > 0,
    wrong: false,
  }
}

const props = __props

const emit = __emit

const password: Ref<PasswordCurrent> = ref({
  value: '',
  valid: false,
  errorCode: undefined,
  length: false,
  wrong: false,
})
const enablePasswordValidation = ref(false)
const showPassword = ref(false)
const inputField = ref(null)

watch(
  () => props.modelValue,
  (to: PasswordCurrent) => {
    password.value = to
  },
  { deep: true },
)

watch(
  () => props.validate,
  (to: boolean) => {
    enablePasswordValidation.value = to
    if (enablePasswordValidation.value) {
      password.value = _validatePassword(password.value.value)
    }
  },
)
/**
 * Declare event-handlers for input fields and register handlers defined on the outside (in parent component)
 *
 * @return  {[event:string]: Function}  Map of event-handlers, applied in template via attribute "v-on"
 */
const listeners = computed(() => {
  return {
    ...attrs,
    blur: onPasswordBlur,
    input: (event: InputEvent) => validatePassword((event.target as HTMLInputElement).value),
  }
})

/**
 * Public method to invoke bluring the actual text-input
 *
 * @return  {void}
 */
const blur = () => {
  inputField.value.blur()
}

const validatePassword = (s: string) => {
  // TODO move out validation logic and unit test it !!!
  password.value = _validatePassword(s)
  if (s.length === 0 || password.value.valid) {
    enablePasswordValidation.value = false
    emit('reset')
  }
  emit('update:modelValue', password.value)
}

const onPasswordBlur = () => {
  // password.value = _validatePassword(this.password.value)
}

__expose({
  blur,
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.$t('form.label.passwordCurrent')), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("input", _mergeProps({
        ref_key: "inputField",
        ref: inputField,
        autocomplete: "current-password",
        "data-qe-id": "password-current",
        class: enablePasswordValidation.value && (!password.value.valid || password.value.errorCode) ? 'error' : '',
        value: password.value.value,
        type: showPassword.value ? 'text' : 'password'
      }, _toHandlers(listeners.value, true), {
        placeholder: _ctx.$t('form.placeholder.passwordCurrent')
      }), null, 16, _hoisted_4),
      _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (showPassword.value = true)),
        class: "eye-on-icon icf-colorblindOn"
      }),
      _createElementVNode("div", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (showPassword.value = false)),
        class: "eye-off-icon icf-colorblindOff"
      })
    ]),
    (enablePasswordValidation.value && password.value.errorCode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$t(`form.errors.${password.value.errorCode}`)), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})